<template>
<div id="aquaculture">
        <div class="top-row">
          <figure class="figure">
             <img @click="selectAquaculture($store.state.calc.Aquaculture.pff,
             '37.ogg')"
            :alt="translate.pff"
            :title="translate.pff"
            class="img-fluid"
            src="../assets/Pond_fish_farming.jpg">
            <figcaption class="figure-caption text-center">
              {{ translate.pff }}</figcaption>
          </figure>
          <figure class="figure">
            <img @click="selectAquaculture($store.state.calc.Aquaculture.cage,
            '36.ogg')"
            :alt="translate.cage"
            :title="translate.cage"
            class="img-fluid"
            src="../assets/Cage.jpg">
            <figcaption class="figure-caption text-center">
              {{ translate.cage }}</figcaption>
          </figure>
          <figure class="figure">
            <img @click="selectAquaculture($store.state.calc.Aquaculture.lcff,
             '35.ogg')"
            :alt="translate.lcff"
            :title="translate.lcff"
            class="img-fluid"
            src="../assets/Lakes_commercial_fish_farming.jpg">
          <figcaption class="figure-caption text-center">
            {{ translate.lcff }}</figcaption>
          </figure>
          <figure class="figure">
            <img @click="selectAquaculture($store.state.calc.Aquaculture.cwsi,
             '38.ogg')"
            :alt="translate.cwsi"
            :title="translate.cwsi"
            class="img-fluid"
            src="../assets/Closed_water_supply_installation.jpg">
            <figcaption class="figure-caption text-center">
              {{ translate.cwsi }}</figcaption>
          </figure>
        </div>
        <div class="middle-row">

          </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  computed: {
    translate() {
      const lang = this.$store.state.calc.currentLocale;
      return this[lang];
    },

  },
  data() {
    return {
      kz: {
        pff: 'Тоған шаруашылығы',
        cage: 'Шарбақ шаруашылығы',
        lcff: 'Көл-тауарлы балық шаруашылығы',
        cwsi: 'Тұйықталған су жүйесі',
      },
      ru: {
        pff: 'Прудовое рыбоводство',
        cage: 'Садковое хозяйство',
        lcff: 'Озерно товарное рыбоводное хозяйство',
        cwsi: 'Установка замкнутого водоснабжения',
      },
    };
  },
  created() {
    this.$say('1.ogg');
  },
  methods: {
    ...mapActions('calc', ['setAquaculture']),
    selectAquaculture(item, text) {
      this.setAquaculture(item);
      this.$router.push('AquacultureObject');
      this.$say(text);
    },
  },

};
</script>

<style scoped>
.top-row {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
}
.top-row>* {
    padding: 25px;
}


img:hover{
    cursor: pointer;
}
</style>
